import { render, staticRenderFns } from "./BeefParasiteManagement.vue?vue&type=template&id=5e854afa&"
import script from "./BeefParasiteManagement.vue?vue&type=script&lang=js&"
export * from "./BeefParasiteManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports